import React, { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';
import { addOnlineStatusListener } from '../utils/pwaUtils';

export const PWAStatusBar: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const unsubscribe = addOnlineStatusListener(
      () => setIsOnline(true),
      () => setIsOnline(false)
    );

    return unsubscribe;
  }, []);

  if (isOnline) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-orange-500 text-white px-4 py-2 flex items-center gap-2 z-50">
      <WifiOff size={18} />
      <span className="text-sm font-medium">You are offline. Some features may be limited.</span>
    </div>
  );
};

export default PWAStatusBar;
